import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

class ConfiguratorView extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleChange = name => event => {
        //if (name == "question1") 
        //event.target.value
    }

    render() {
        return (
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                <Grid container spacing={3}>
                  
                    <Grid item xs={12} md={12} lg={6}>

                        <Paper
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                height: 240,
                            }}
                        >
                            <h2>Configurators administration</h2>                           
                        </Paper>
                    </Grid>

                
                    <Grid item xs={12} md={12} lg={6}>

                        <Paper
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                height: 240,
                            }}
                        >
                            <h2>BIM configuration for projects</h2>
                            
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        )
    }
}

export default ConfiguratorView;